import { render, staticRenderFns } from "./navigate.vue?vue&type=template&id=2ea74db0&scoped=true&"
import script from "./navigate.vue?vue&type=script&lang=js&"
export * from "./navigate.vue?vue&type=script&lang=js&"
import style0 from "./navigate.vue?vue&type=style&index=0&id=2ea74db0&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea74db0",
  null
  
)

export default component.exports